import '../Scss/style.scss';

import Alpine from 'alpinejs';
import AlpineI18n from 'alpinejs-i18n';
import AsyncAlpine from 'async-alpine';

import GoogleMaps from './components/GoogleMaps';
import Header from './components/Header';
import MainTopicsCategoryList from './components/MainTopicsCategoryList';
import NewsList from './components/NewsList';
import ServiceLinksList from './components/ServiceLinksList';
import BookTipsList from './components/BookTipsList/index.ts';
import OrderItemList from './components/OrderItemList/index.ts';
import ProviderEditForm from './components/ProviderEditForm';
import ProvidersList from './components/ProvidersList/index.ts';
import Search from './components/Search/index.ts';
import SeminarsCategoryList from './components/SeminarsCategoryList';
import SeminarsList from './components/SeminarsList/index.ts';
import SeminarsEditForm from './components/SeminarsEditForm';
import ImportForm from './components/ImportForm';

import SearchSeminarsWidget from './components/widgets/SearchSeminarsWidget';

import 'dom-slider';
import Awesomplete from './plugins/awesomplete';
import Cookie from './plugins/cookies-info-box';
import Datepicker from "./plugins/datepicker";
import DetectLoading from './plugins/detect-loading';
import EditorJS from './plugins/editor-js';
import EmbedVideos from './plugins/embed-videos';
import Fancybox from './plugins/fancybox';
import Headings from './plugins/headings';
import LazyLoad from './plugins/lazyload';
import SAL from './plugins/sal';
import ScrollOffset from './plugins/scroll-offset';
import ScrollToTop from './plugins/scroll-to-top';
import VideoPlayer from './plugins/video-player';
import './utils/i18n';

function CookiesInfoBox(Alpine: any) {
  Alpine.data('CookiesInfoBox', () => Cookie);
}

AsyncAlpine.init(Alpine);
AsyncAlpine.start();

Alpine.data('BookTipsList', BookTipsList);
Alpine.data('GoogleMaps', GoogleMaps);
Alpine.data('Header', Header);
Alpine.data('ImportForm', ImportForm);
Alpine.data('MainTopicsCategoryList', MainTopicsCategoryList);
Alpine.data('NewsList', NewsList);
Alpine.data('OrderItemList', OrderItemList);
Alpine.data('ProviderEditForm', ProviderEditForm);
Alpine.data('ProvidersList', ProvidersList);
Alpine.data('Search', Search);
Alpine.data('SearchSeminarsWidget', SearchSeminarsWidget);
Alpine.data('SeminarsCategoryList', SeminarsCategoryList);
Alpine.data('SeminarsList', SeminarsList);
Alpine.data('SeminarsEditForm', SeminarsEditForm);
Alpine.data('ServiceLinksList', ServiceLinksList);

Alpine.plugin(AlpineI18n);
Alpine.plugin(Awesomplete);
Alpine.plugin(CookiesInfoBox);
Alpine.plugin(Datepicker);
Alpine.plugin(DetectLoading);
Alpine.plugin(EditorJS);
Alpine.plugin(EmbedVideos);
Alpine.plugin(Fancybox);
Alpine.plugin(Headings);
Alpine.plugin(LazyLoad);
Alpine.plugin(SAL);
Alpine.plugin(ScrollOffset);
Alpine.plugin(ScrollToTop);
Alpine.plugin(VideoPlayer);

window.Alpine = Alpine;
Alpine.start();

// Initialize Cookie and add event listener for frameLoaded
Cookie.init();
document.addEventListener('frameLoaded', () => {
  Cookie.checkSettings();
});
